import { vars } from '@etg/wings';
import { css } from '@eti/styles';
export const wrapperStyles = shouldShowTaxIdInput => css`
  border-end-end-radius: ${shouldShowTaxIdInput ? '0' : vars.card.borderRadius};
  border-end-start-radius: ${shouldShowTaxIdInput ? '0' : vars.card.borderRadius};
  transition: border-radius 0.2s linear;
`;
//# sourceMappingURL=styles.js.map